export const GoogleMapApiConfig = 'AIzaSyDyZjmIz63Ysh9jA-cZnLsWaioig1udkoY';